/** ルート進入前の先回りモーダルの文言: 配信ルート */
export const preroutePromptLive = {
  /** サムネ一覧（消費直前・配信志向の人の物色）: 見出し */
  listTitle: "いま配信中の女の子",
  /** サムネ一覧: CTA 下の値段。配信ごとに違うときは一番安い値段に「〜」 */
  listPrice: (args: { point: string | number; varies: boolean }) =>
    `${args.point}pt/1分${args.varies ? "〜" : ""}`,
  /** サムネ一覧: CTA（ライブ一覧へ） */
  listCta: "ほかの配信も見る",
} as const;
